import { Tag } from 'antd';
import React, { FC, memo } from 'react';

import { DomainSchemeRedirect } from '../../domains.interfaces';

interface Props {
  redirect: DomainSchemeRedirect;
}

export const DomainsSchemeRedirectTag: FC<Props> = memo(({ redirect }) => {
  if (redirect === DomainSchemeRedirect.None) {
    return <Tag>Немає</Tag>;
  }

  if (redirect === DomainSchemeRedirect.HttpToHttps) {
    return (
      <Tag>
        З&nbsp;<strong>HTTP</strong>&nbsp;на&nbsp;<strong>HTTPS</strong>
      </Tag>
    );
  }

  if (redirect === DomainSchemeRedirect.HttpsToHttp) {
    return (
      <Tag>
        З&nbsp;<strong>HTTPS</strong>&nbsp;на&nbsp;<strong>HTTP</strong>
      </Tag>
    );
  }

  return <Tag></Tag>;
});
